import { Link } from 'react-router-dom';
import { BrandLogo } from '@/context/BrandingContext';

export default function LandingFooter() {
  return (
    <footer className="py-16 px-6" style={{ backgroundColor: '#2C2520', paddingBottom: '80px' }} data-testid="landing-footer">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-4">
          <BrandLogo
            slot="footer"
            className="h-[63px] mx-auto"
            fallback={<span className="text-[16px] font-semibold" style={{ color: '#F0EBE3' }}>GetChosenFirst</span>}
          />
        </div>
        <p className="text-center mb-10" style={{ fontFamily: "'Playfair Display', serif", fontStyle: 'italic', fontSize: '14px', color: 'rgba(240,235,227,0.5)' }}>Giving the power back to you.</p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
          {[{ title: 'PRODUCT', links: [{ label: 'Features', href: '/#how-it-works' }, { label: 'Pricing', href: '/pricing' }, { label: 'Scan', href: '/' }] }, { title: 'PROFESSIONS', links: [{ label: 'Plumbers', href: '/for/plumbers' }, { label: 'Stylists', href: '/for/stylists' }, { label: 'Dentists', href: '/for/dentists' }, { label: 'Lawyers', href: '/for/lawyers' }] }, { title: 'COMPANY', links: [{ label: 'About', href: '#' }, { label: 'Contact', href: '#' }, { label: 'Blog', href: '#' }] }, { title: 'LEGAL', links: [{ label: 'Privacy', href: '#' }, { label: 'Terms', href: '/terms' }, { label: 'Cookies', href: '#' }] }].map(col => (
            <div key={col.title}>
              <p style={{ color: '#F0EBE3', fontSize: '11px', letterSpacing: '0.1em', fontWeight: 500 }} className="mb-3">{col.title}</p>
              {col.links.map(link => (<Link key={link.label} to={link.href} className="block transition-colors mb-2" style={{ color: '#8C7E6E', fontSize: '11px', letterSpacing: '0.1em', textTransform: 'uppercase' }} onMouseEnter={e => e.target.style.color = '#F0EBE3'} onMouseLeave={e => e.target.style.color = '#8C7E6E'}>{link.label}</Link>))}
            </div>
          ))}
        </div>
        <p className="text-center" style={{ color: '#8C7E6E', fontSize: '10px' }}>&copy; {new Date().getFullYear()} GetChosenFirst</p>
      </div>
    </footer>
  );
}
